import * as React from "react";
import type { SVGProps } from "react";
const SvgSuccess = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={96}
    height={96}
    fill="none"
    viewBox="0 0 81 80"
    {...props}
  >
    <path
      fill="url(#success_svg__a)"
      fillRule="evenodd"
      d="M40.5 70c16.569 0 30-13.431 30-30 0-16.568-13.431-30-30-30-16.568 0-30 13.432-30 30 0 16.569 13.432 30 30 30m15.254-38.4a2.5 2.5 0 1 0-3.841-3.2L36.999 46.297l-8.065-8.065a2.5 2.5 0 0 0-3.535 3.536l10 10a2.5 2.5 0 0 0 3.688-.168z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="success_svg__a"
        x1={11.326}
        x2={81.62}
        y1={12.278}
        y2={48.297}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#18A09F" />
        <stop offset={1} stopColor="#050033" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgSuccess;
